import { EventPage, GetStaticProps } from "@/bet-nextv1/pages/EventPage";

export default EventPage;

export const getStaticProps = GetStaticProps;
